import { FormHelperText, styled } from "@mui/material";

export const ValidationError = styled(FormHelperText)(({ theme }) => ({
  minHeight: "20px",
  color: theme.palette.error.main,
}));
